// extracted by mini-css-extract-plugin
export default {"buttons-container":"authenticationNotice_buttons-container__B1KIR"};